var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7185 5.87344C15.2906 7.28402 15.4042 8.83887 15.0432 10.3176C14.6821 11.7963 13.8649 13.1239 12.7072 14.1122C11.5495 15.1005 10.1101 15.6993 8.59302 15.8239C7.07596 15.9484 5.55819 15.5922 4.25485 14.8059C2.9515 14.0196 1.92871 12.843 1.33144 11.4429C0.734167 10.0428 0.592717 8.49028 0.927139 7.00531C1.26156 5.52033 2.05489 4.17829 3.19467 3.16939C4.33446 2.1605 5.76288 1.53594 7.27746 1.38424",
    stroke: "#5CB1A3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.59814L8 11.5981L13.5 2.59814",
    stroke: "#5CB1A3",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.af0f486f20fc1692c5f0bee46fd5b32a.svg";
export { ForwardRef as ReactComponent };